module.exports = __webpack_public_path__ + "static/media/Queen.dafbf8b4.jpg";